
import React from 'react'
import UPopup from "ubs-framework/v2/UPopup";

export const showMoreText = (text, text_length) => {

    let more_text = text?.length > text_length ? text?.substr(0, text_length - 1) : text;
    let f_text = window.innerWidth < 1366 ? more_text?.substr(0, text_length) : more_text;

    return (
        <React.Fragment>
            <span className="u_word-break-word">
                {f_text}
                {text?.length > text_length &&
                    <UPopup
                        params={{ className: "u_tooltip u_tooltip_more", position: 'bottom center', defaultOpen: true }}
                        desc={<div className="u_popover-more-text">
                            <div className="u_popover-more-text-inner">
                                <span>{text}</span>
                            </div>
                        </div>}
                    >
                        <span className="u_table-more-text u_cp">...Read More</span>
                    </UPopup>}
            </span>
        </React.Fragment>
    );
}
